import React from 'react';
import { Container } from '@chakra-ui/react';
// import './App.css';

import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './homes/Home';
// import Menu from './Menu';
import MenuNew from './MenuNew';
import CheckoutOK from './CheckoutOK';
import CheckoutCancel from './CheckoutCancel';
import CheckoutVoucherNotFound from './CheckoutVoucherNotFound';
import CheckoutVoucherDepleted from './CheckoutVoucherDepleted';
import CheckoutVoucherExpired from './CheckoutVoucherExpired';
import Order from './Order';
import Sponsor from './Sponsor';
import Support from './Support';
import Promo from './Promo';
import Dashboard from './dashboard/Dashboard';
import Realtime from './dashboard/realtime/Realtime';
import EventDates from './dashboard/event-dates/EventDates';
import OperatorsStats from './dashboard/operators-stats/OperatorsStats';
import Voucher from './dashboard/voucher/Voucher';
import WarehousePage from './dashboard/warehouse/WarehousePage';
import UsersPage from './dashboard/users/UsersPage';
import ProductDetail from './ProductDetail';
import MenuAdminPage from './dashboard/MenuAdminPage';
import CashierMonitor from './dashboard/CashierMonitor';

import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './api';
import QuickLogin from './components/QuickLogin';
import { useAppSettings } from './contexts/app-settings-ctx';

export default function App() {

  // Per Cassa ingrandisci la vista cassa al 100% e 60% su lg
  const [user] = useAuthState(auth);
  const isCashier = user?.displayName === 'cashier';
  const isAdmin = user?.displayName === 'admin';
  const { appSettings } = useAppSettings();
  const adminCashierEnabled = !!appSettings?.adminCashier;
  const isCashierOrAdminCashier = isCashier || (isAdmin && adminCashierEnabled);
  const location = useLocation();
  const isMenu = location.pathname === '/menu';
  const isRealtime = location.pathname === '/dashboard/realtime';
  const isEditorMenu = location.pathname === '/dashboard/menu-admin';
  const isCashierMonitor = location.pathname === '/dashboard/cashier-monitor';

  const isLocal = window.location.hostname === 'localhost';
  
  let maxW
  let minW
  if (isCashierMonitor || isEditorMenu || isMenu && isCashierOrAdminCashier) {
    maxW = { base: '100%', lg: '60%' };
  } else if (isRealtime) {
    // solo per visualizzare bene su iphone
    minW = '600px';
  }

  return (
    <>
      {isLocal && <QuickLogin />}
      <Container
        my={50}
        bg='#3c4d5f'
        centerContent
        borderRadius={15}
        borderColor='white'
        borderWidth={1}
        maxWidth={maxW}
        minWidth={minW}
      >
      <Routes>
        <Route path='/' element={<Home />} />
        {/* <Route path='menu' element={<Menu />} /> */}
        <Route path='menu' element={<MenuNew />} />
        <Route path='sponsor' element={<Sponsor />} />
        <Route path='support' element={<Support />} />
        <Route path='promo' element={<Promo />} />
        <Route path='product/:productId' element={<ProductDetail />} />
        <Route path='checkout-ok/:orderId' element={<CheckoutOK />} />
        <Route path='checkout-cancel/:orderId' element={<CheckoutCancel />} />
        <Route
          path='checkout-voucher-not-found/:orderId/:code'
          element={<CheckoutVoucherNotFound />}
        />
        <Route
          path='checkout-voucher-depleted/:orderId/:code'
          element={<CheckoutVoucherDepleted />}
        />
        <Route
          path='checkout-voucher-expired/:orderId/:code'
          element={<CheckoutVoucherExpired />}
        />
        <Route path='order/:orderId' element={<Order />} />
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='dashboard/menu-admin' element={<MenuAdminPage />} />
        <Route path='dashboard/realtime' element={<Realtime />} />
        <Route path='dashboard/event-dates' element={<EventDates />} />
        <Route path='dashboard/operators-stats' element={<OperatorsStats />} />
        <Route path='dashboard/voucher' element={<Voucher />} />
        <Route path='dashboard/warehouse' element={<WarehousePage />} />
        <Route path='dashboard/users' element={<UsersPage />} />
        <Route path='dashboard/cashier-monitor' element={<CashierMonitor />} />
        {/* <Route path='order' element={<ReaderQR/>} /> */}
        <Route
          path='*'
          element={
            <main style={{ padding: '1rem', color: 'white' }}>
              <p>Pagina non trovata</p>
            </main>
          }
        />
      </Routes>
      </Container>
    </>
  );
}
